export const WORDS = [
'first',
'glory',
'angel',
'curse',
'sunny',
'witch',
'watch',
'joyce',
'raise',
'wicca',
'magic',
'point',
'knife',
'giles',
'demon',
'trick',
'blood',
'three',
'walsh',
'arise',
'cross',
'grave',
'foamy',
'cordy',
'dingo',
'angst',
'spell',
'mayor',
'spike',
'bites',
'hyena',
'stake',
'katra',
'ghost',
'vamps',
'buffy',
'zeppo',
'faith',
'slays',
'lunar',
'gypsy',
'moons',
'hairy',
'souls',
'drown',
'growl',
'campy',
'glows',
'scoob',
'ghoul',
'moods',
'sarah',
'darla',
'angst',
'doyle',
'fyarl',
'willy',
'wound',
'bicon',
'tough',
'snarl',
'prays',
'skins',
'latin',
'books',
'night',
'fight',
'world',
'bless',
'weird',
'pouty',
'dance',
'crush', 'candy', 'dirty', 'dummy', 'arrow', 'scary', 'dawny', 'gorch', 'kathy', 'ethan', 'april', 'guide', 'allan', 'finch', 'caleb', 'robin', 'award', 'nikki', 'blond', 'cheer', 'class', 'quell', 'onion',
'bomwf',
'music',
]
